import { useEffect, useState } from 'react';
import { useAuth } from '../../context/AuthContext';
import api from '../../services/api';
import ProjectCard from '../../components/project/ProjectCard';

const AnalyticsPage = () => {
  const { user } = useAuth();
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchProjects = async () => {
      if (!user) return;

      try {
        // ✅ Правильный путь: /analytics/projects (совпадает с @api.route)
        const res = await api.get('/analytics/projects');

        // ✅ Извлекаем массив из res.data.projects
        const data = res.data?.projects;

        if (Array.isArray(data)) {
          setProjects(data);
        } else {
          console.warn('Неверный формат данных:', res.data);
          setProjects([]);
        }
      } catch (err) {
        console.error('Ошибка загрузки проектов:', err);
        console.error('Ответ сервера:', err.response?.data);
        setProjects([]);
      } finally {
        setLoading(false);
      }
    };

    fetchProjects();
  }, [user]);

  // Если не авторизован
  if (!user) return <div className="p-4">Доступ запрещён.</div>;

  // Если загружается
  if (loading) return <div className="p-4">Загрузка проектов...</div>;

  return (
    <div className="main-content">
      <h1>Выберите проект</h1>
      <div className="row g-3">
        {projects.length === 0 ? (
          <div className="col-12">
            <div className="alert alert-warning">У вас нет доступных проектов</div>
          </div>
        ) : (
          projects.map((project) => (
            <div className="col-md-4 col-sm-6 mb-3" key={project.id}>
              <ProjectCard project={project} />
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default AnalyticsPage;
